var _excluded = ["storageKey", "onceOnly", "noClose", "actionDismisses", "onClose", "onAction"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React, { useCallback } from 'react';
import noop from '../../utils/noop';
import useDismissable from '../../utils/use-dismissable';
import Message from './message';
import { jsx as ___EmotionJSX } from "@emotion/core";
var DismissableMessage = _ref => {
  var storageKey = _ref.storageKey,
    _ref$onceOnly = _ref.onceOnly,
    onceOnly = _ref$onceOnly === void 0 ? false : _ref$onceOnly,
    _ref$noClose = _ref.noClose,
    noClose = _ref$noClose === void 0 ? false : _ref$noClose,
    _ref$actionDismisses = _ref.actionDismisses,
    actionDismisses = _ref$actionDismisses === void 0 ? false : _ref$actionDismisses,
    _ref$onClose = _ref.onClose,
    onClose = _ref$onClose === void 0 ? noop : _ref$onClose,
    _ref$onAction = _ref.onAction,
    onAction = _ref$onAction === void 0 ? noop : _ref$onAction,
    props = _objectWithoutProperties(_ref, _excluded);
  var _useDismissable = useDismissable({
      storageKey,
      onceOnly
    }),
    visible = _useDismissable.visible,
    dismiss = _useDismissable.dismiss;
  var handleClose = useCallback(function () {
    dismiss();
    if (onClose) {
      onClose(...arguments);
    }
  }, [onClose, dismiss]);
  var handleAction = useCallback(function () {
    if (actionDismisses) {
      dismiss();
    }
    if (onAction) {
      onAction(...arguments);
    }
  }, [actionDismisses, onAction, dismiss]);
  return visible ? ___EmotionJSX(Message, _extends({}, props, {
    closeable: !noClose,
    onClose: handleClose,
    onAction: handleAction
  })) : null;
};
export default DismissableMessage;